import { Component } from '@angular/core';

@Component({
  selector: 'sca-cookies-details',
  templateUrl: './cookies-details.component.html',
  styleUrls: ['./cookies-details.component.scss']
})
export class CookiesDetailsComponent {}
